import { useQuery } from '@hooks/reactQuery';

import { getPortalAvailableProjects } from '@api/projectManagement';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_AVAILABLE_PROJECTS } from '@constants/queryKeys';

interface IUseQueryPortalAvailableProjectsReturned {
	portalAvailableProjects: Array<TSelectOption>;
	isLoadingPortalAvailableProjects: boolean;
}

export const useQueryPortalAvailableProjects = (): IUseQueryPortalAvailableProjectsReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_AVAILABLE_PROJECTS],
		queryFn: getPortalAvailableProjects,
		select: requestTypes => optionsFormattedWithIdName(requestTypes),
		...refetchOptions,
	});

	return {
		portalAvailableProjects: data || [],
		isLoadingPortalAvailableProjects: isLoading || isFetching,
	};
};
